import { useMemo } from "react"
import { ENTITY_ROUTES } from "~/router.tsx"

/**
 * @param pathname location pathname
 * @returns document title
 */
export const useDocumentTitle = (pathname: string) =>
  useMemo((): string => {
    if (pathname.includes(`/${ENTITY_ROUTES.Start}`)) {
      return "GlobalGiving - Join"
    }

    if (pathname.includes(`/${ENTITY_ROUTES.ActiveTasks}`) || pathname.includes(`/${ENTITY_ROUTES.CompletedTasks}`)) {
      return "GlobalGiving - Due Diligence Tasks"
    }

    if (pathname.includes(`/${ENTITY_ROUTES.OrganizationUpdate}`)) {
      return "GlobalGiving - Update Organization Details"
    }

    // Default document title
    return "GlobalGiving - Due Diligence"
  }, [pathname])
